module.exports = __webpack_public_path__ + "static/img/博士_2022_张尚昆_kern@nwafu.edu.cn.a11019a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/博士_2022_张尚昆_kern@nwafu.edu.cn.jpg
// module id = 9DbH
// module chunks = 6